import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { config, ENVS } from "@config";
import { STATSIG_INIT_CONFIG } from "@statsig/angular-bindings";
import { StatsigClientService } from "@core-services/statsig/statsig.service";
import packageJson from "../../../../../../package.json";

const StatsigConfig = {
	sdkKey: config.statsigApiKey,
	user: {
		appVersion: packageJson.version,
		custom: {
			platform: "web"
		}
	}, // initial user object
	options: {
		initTimeout: 10.0,
		enableAutoValueUpdate: true,
		environment: {
			tier: config.envName === ENVS.STAGING || config.envName === ENVS.LOCAL ? "staging" : "production"
		},
		networkConfig: {
			api: config.statsigProxyUrl
		}
	}
};

@NgModule({
	declarations: [],
	providers: [
		{
			provide: STATSIG_INIT_CONFIG,
			useValue: StatsigConfig
		},
		StatsigClientService
	],
	imports: [CommonModule]
})
export class StatsigModule {}
